import { createSelector } from 'reselect';

import { RootState } from 'types/store';

export const selectCompletedPlanStatistics = (state: RootState) => state.personalPlan.statistics;
export const selectPlanDays = (state: RootState) => state.personalPlan.planDays;
export const selectIsCurrentPlanComplete = (state: RootState) => state.personalPlan.isCurrentPlanComplete;
export const selectCurrentDay = (state: RootState) => state.personalPlan.currentDay;
export const selectSelectedDay = (state: RootState) => state.personalPlan.selectedDay;
export const selectWorkout = (state: RootState) => state.personalPlan.workout;
export const selectCurrentPlanId = (state: RootState) => state.personalPlan.currentPlanId;
export const selectCurrentPlanLevel = (state: RootState) => state.personalPlan.currentPlanLevel;
export const selectTotalPlanDays = (state: RootState) => state.personalPlan.totalPlanDays;
export const selectIsCompletePlanModalVisible = (state: RootState) => state.personalPlan.isCompletePlanModalVisible;
export const selectYogaType = (state: RootState) => state.personalPlan.yogaType;
export const selectPersonalPlan = (state: RootState) => state.personalPlan;
export const selectPlanType = (state: RootState) => state.personalPlan.planType;
export const selectIsPlanConfigurable = (state: RootState) => state.personalPlan.isPlanConfigurable;
export const selectPlanLevel = (state: RootState) => state.personalPlan.currentPlanLevel;
export const selectInstructor = (state: RootState) => state.personalPlan.instructor;
export const selectIsCurrentPlanFetched = (state: RootState) => state.personalPlan.isCurrentPlanFetched;

export const selectActiveDay = createSelector(
    [selectSelectedDay, selectCurrentDay],
    (selectedDay, currentDay) => selectedDay ?? currentDay
);

export const selectActiveWorkout = createSelector([selectPlanDays, selectActiveDay], (days, activeDay) =>
    days.find((w) => w.day_number === activeDay)
);

export const selectDayOneWorkout = createSelector([selectPlanDays], (days) => days.find((day) => day.day_number === 1));

export const selectIsFirstWorkoutCompleted = createSelector([selectDayOneWorkout], (dayOneWorkout) =>
    Boolean(dayOneWorkout?.completion_date)
);
